import { render, staticRenderFns } from "./JoinTermsView.vue?vue&type=template&id=4b99cba9&scoped=true&"
import script from "./JoinTermsView.vue?vue&type=script&lang=js&"
export * from "./JoinTermsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b99cba9",
  null
  
)

export default component.exports